<template>
  <div class="bottom_tab_bar space-between">
    <div
      class="d-flex-row flex-10 gap-2 bottom_tab"
      v-if="!user.getUserLoggedIn"
    >
      <div class="d-flex-column flex-4">
        <NuxtLinkLocale
          :to="'/login'"
          class="primary filled logged_nav flex-4 f-w-600 b-radius-4 medium-xs font-family-2"
        >
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.47 2.33C21.75 1.51 20.68 1 19.5 1C18.38 1 17.36 1.46 16.63 2.21C16.21 2.64 15.89 3.16 15.7 3.74C15.57 4.14 15.5 4.56 15.5 5C15.5 5.75 15.71 6.46 16.08 7.06C16.28 7.4 16.54 7.71 16.84 7.97C17.54 8.61 18.47 9 19.5 9C19.94 9 20.36 8.93 20.75 8.79C21.67 8.5 22.44 7.87 22.92 7.06C23.13 6.72 23.29 6.33 23.38 5.93C23.46 5.63 23.5 5.32 23.5 5C23.5 3.98 23.11 3.04 22.47 2.33ZM20.99 5.73H20.25V6.51C20.25 6.92 19.91 7.26 19.5 7.26C19.09 7.26 18.75 6.92 18.75 6.51V5.73H18.01C17.6 5.73 17.26 5.39 17.26 4.98C17.26 4.57 17.6 4.23 18.01 4.23H18.75V3.52C18.75 3.11 19.09 2.77 19.5 2.77C19.91 2.77 20.25 3.11 20.25 3.52V4.23H20.99C21.4 4.23 21.74 4.57 21.74 4.98C21.74 5.39 21.41 5.73 20.99 5.73Z"
              fill="#050607"
            />
            <path
              d="M22.5 12C22.5 10.69 22.25 9.43 21.78 8.28C21.47 8.5 21.12 8.67 20.75 8.79C20.64 8.83 20.53 8.86 20.41 8.89C20.79 9.85 21 10.9 21 12C21 14.32 20.06 16.43 18.54 17.97C18.25 17.6 17.88 17.26 17.44 16.97C14.73 15.15 10.29 15.15 7.56 16.97C7.12 17.26 6.76 17.6 6.46 17.97C4.94 16.43 4 14.32 4 12C4 7.31 7.81 3.5 12.5 3.5C13.59 3.5 14.64 3.71 15.6 4.09C15.63 3.97 15.66 3.86 15.7 3.74C15.82 3.37 15.99 3.03 16.22 2.72C15.07 2.25 13.81 2 12.5 2C6.99 2 2.5 6.49 2.5 12C2.5 14.9 3.75 17.51 5.73 19.34C5.73 19.35 5.73 19.35 5.72 19.36C5.82 19.46 5.94 19.54 6.04 19.63C6.1 19.68 6.15 19.73 6.21 19.77C6.39 19.92 6.59 20.06 6.78 20.2C6.85 20.25 6.91 20.29 6.98 20.34C7.17 20.47 7.37 20.59 7.58 20.7C7.65 20.74 7.73 20.79 7.8 20.83C8 20.94 8.21 21.04 8.43 21.13C8.51 21.17 8.59 21.21 8.67 21.24C8.89 21.33 9.11 21.41 9.33 21.48C9.41 21.51 9.49 21.54 9.57 21.56C9.81 21.63 10.05 21.69 10.29 21.75C10.36 21.77 10.43 21.79 10.51 21.8C10.79 21.86 11.07 21.9 11.36 21.93C11.4 21.93 11.44 21.94 11.48 21.95C11.82 21.98 12.16 22 12.5 22C12.84 22 13.18 21.98 13.51 21.95C13.55 21.95 13.59 21.94 13.63 21.93C13.92 21.9 14.2 21.86 14.48 21.8C14.55 21.79 14.62 21.76 14.7 21.75C14.94 21.69 15.19 21.64 15.42 21.56C15.5 21.53 15.58 21.5 15.66 21.48C15.88 21.4 16.11 21.33 16.32 21.24C16.4 21.21 16.48 21.17 16.56 21.13C16.77 21.04 16.98 20.94 17.19 20.83C17.27 20.79 17.34 20.74 17.41 20.7C17.61 20.58 17.81 20.47 18.01 20.34C18.08 20.3 18.14 20.25 18.21 20.2C18.41 20.06 18.6 19.92 18.78 19.77C18.84 19.72 18.89 19.67 18.95 19.63C19.06 19.54 19.17 19.45 19.27 19.36C19.27 19.35 19.27 19.35 19.26 19.34C21.25 17.51 22.5 14.9 22.5 12Z"
              fill="#050607"
            />
            <path
              d="M12.5 6.93018C10.43 6.93018 8.75 8.61018 8.75 10.6802C8.75 12.7102 10.34 14.3602 12.45 14.4202C12.48 14.4202 12.52 14.4202 12.54 14.4202C12.56 14.4202 12.59 14.4202 12.61 14.4202C12.62 14.4202 12.63 14.4202 12.63 14.4202C14.65 14.3502 16.24 12.7102 16.25 10.6802C16.25 8.61018 14.57 6.93018 12.5 6.93018Z"
              fill="#050607"
            />
          </svg>

          {{ $t("login.register") }}
        </NuxtLinkLocale>
      </div>
      <div class="d-flex-column flex-4">
        <NuxtLinkLocale
          :to="'/login'"
          class="t-grey logged_nav f-w-600 flex-4 b-radius-4 medium-xs font-family-2"
        >
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.3 2H14.7C11.5 2 9.5 4 9.5 7.2V11.25H13.94L11.87 9.18C11.72 9.03 11.65 8.84 11.65 8.65C11.65 8.46 11.72 8.27 11.87 8.12C12.16 7.83 12.64 7.83 12.93 8.12L16.28 11.47C16.57 11.76 16.57 12.24 16.28 12.53L12.93 15.88C12.64 16.17 12.16 16.17 11.87 15.88C11.58 15.59 11.58 15.11 11.87 14.82L13.94 12.75H9.5V16.8C9.5 20 11.5 22 14.7 22H17.29C20.49 22 22.49 20 22.49 16.8V7.2C22.5 4 20.5 2 17.3 2Z"
              fill="#CBCBCB"
            />
            <path
              d="M3.25 11.25C2.84 11.25 2.5 11.59 2.5 12C2.5 12.41 2.84 12.75 3.25 12.75H9.5V11.25H3.25Z"
              fill="#CBCBCB"
            />
          </svg>

          {{ $t("login.login") }}
        </NuxtLinkLocale>
      </div>

      <div class="d-flex-column flex-4">
        <button class="flex-3 d-flex-column gap-5" @click="openMenu">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.21603 0.400391C2.16377 0.400391 0.5 2.06408 0.5 4.11633C0.5 6.16859 2.16377 7.83228 4.21603 7.83228C6.26829 7.83228 7.93205 6.16859 7.93205 4.11633C7.93205 2.06408 6.26829 0.400391 4.21603 0.400391ZM4.21603 12.168C2.16377 12.168 0.5 13.8317 0.5 15.8839C0.5 17.9362 2.16377 19.5999 4.21603 19.5999C6.26829 19.5999 7.93205 17.9362 7.93205 15.8839C7.93205 13.8317 6.26829 12.168 4.21603 12.168ZM12.2674 4.11633C12.2674 2.06408 13.9312 0.400391 15.9834 0.400391C18.0357 0.400391 19.6994 2.06408 19.6994 4.11633C19.6994 6.16859 18.0357 7.83228 15.9834 7.83228C13.9312 7.83228 12.2674 6.16859 12.2674 4.11633ZM15.9832 12.168C13.931 12.168 12.2672 13.8317 12.2672 15.8839C12.2672 17.9362 13.931 19.5999 15.9832 19.5999C18.0355 19.5999 19.6993 17.9362 19.6993 15.8839C19.6993 13.8317 18.0355 12.168 15.9832 12.168Z"
              fill="#CBCBCB"
            />
          </svg>

          <label class="t-light medium-xs font-family-2">{{
            $t("main.nav.menu")
          }}</label>
        </button>
      </div>
    </div>

    <div class="d-flex-row space-between" v-if="user.getUserLoggedIn">
      <NuxtLinkLocale
        to="/dashboard"
        class="flex-3 d-flex-column gap-2 bottom_tab"
      >
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9748 5.92563C19.8562 5.92563 18.9495 5.01887 18.9495 3.90032C18.9495 2.78176 19.8562 1.875 20.9748 1.875C22.0934 1.875 23.0001 2.78176 23.0001 3.90032C23.0001 5.01887 22.0934 5.92563 20.9748 5.92563Z"
            fill="#9A9A9A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.9367 3.90033C17.9367 5.57815 19.2968 6.9383 20.9747 6.9383C21.5214 6.9383 22.0344 6.79389 22.4776 6.54112C22.5391 6.83828 22.5857 7.15114 22.6216 7.48157C22.7468 8.63814 22.7468 10.096 22.7468 11.9557V12.0475C22.7468 13.9072 22.7468 15.365 22.6216 16.5216C22.4937 17.7019 22.2281 18.6582 21.6347 19.4748C21.2756 19.9691 20.8409 20.4038 20.3466 20.7629C19.53 21.3562 18.5738 21.6218 17.3934 21.7497C16.2369 21.875 14.779 21.875 12.9193 21.875H12.8275C10.9678 21.875 9.50996 21.875 8.3534 21.7497C7.1731 21.6218 6.21677 21.3562 5.40024 20.7629C4.90591 20.4038 4.4712 19.9691 4.11205 19.4748C3.51881 18.6582 3.25317 17.7019 3.1253 16.5216C2.99999 15.365 2.99999 13.9072 3 12.0474V11.9557C2.99999 10.096 2.99999 8.63816 3.1253 7.48157C3.25317 6.30128 3.51881 5.34494 4.11205 4.52842C4.4712 4.03409 4.90591 3.59937 5.40024 3.24022C6.21677 2.64698 7.1731 2.38135 8.3534 2.25347C9.50998 2.12816 10.9678 2.12816 12.8276 2.12817H12.9192C14.779 2.12816 16.2369 2.12816 17.3934 2.25347C17.7238 2.28927 18.0368 2.33586 18.3339 2.39742C18.0811 2.84061 17.9367 3.3536 17.9367 3.90033ZM18.6186 9.44276C18.8033 9.06617 18.6478 8.61113 18.2712 8.4264C17.8946 8.24167 17.4396 8.39721 17.2548 8.77379L15.776 11.7885C15.3177 12.723 13.9704 12.6773 13.5764 11.714C12.6861 9.53776 9.64258 9.43468 8.60707 11.5457L7.12825 14.5604C6.94352 14.937 7.09906 15.3921 7.47565 15.5768C7.85223 15.7615 8.30727 15.6059 8.492 15.2293L9.97082 12.2147C10.4292 11.2802 11.7764 11.3258 12.1704 12.2892C13.0608 14.4654 16.1042 14.5685 17.1397 12.4575L18.6186 9.44276Z"
            fill="#9A9A9A"
          />
        </svg>
        <label class="t-light medium-xs font-family-2">{{
          $t("main.nav.dashboard")
        }}</label>
      </NuxtLinkLocale>

      <button class="flex-3 d-flex-column gap-2 bottom_tab" @click="openChat">
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.6 21.5C15.1303 21.5 17.5135 20.5259 19.3107 18.757C23.035 15.2442 23.0631 8.84101 19.3938 5.28707C15.8572 1.57023 9.42914 1.5655 5.88481 5.30577C4.08204 7.12599 3.10218 9.53148 3.12542 12.0794L3.125 20.5722C3.125 20.9474 3.35099 21.2857 3.69769 21.4294C4.0409 21.5722 4.44256 21.495 4.70872 21.2283L4.85104 21.086C5.41867 20.5184 6.17022 20.1788 6.91291 20.1543C7.36532 20.1395 7.85985 20.2595 8.34328 20.5018C9.66497 21.1642 11.0942 21.5 12.5909 21.5H12.6Z"
            fill="#9A9A9A"
          />
        </svg>
        <label class="t-light medium-xs font-family-2">{{
          $t("main.nav.messages")
        }}</label>
        <div
          class="unread_count font-family-1 t-black bold-s"
          v-if="user.getUnreadMessage > 0"
        >
          {{ user.getUnreadMessage }}
        </div>
      </button>

      <button
        class="flex-3 d-flex-column gap-2 bottom_tab"
        @click="openNotificaiton"
      >
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.5213 15.7194C21.02 15.7194 20.5392 15.5203 20.1847 15.1658C19.8302 14.8113 19.6311 14.3305 19.6311 13.8292V9.25606C19.6311 7.33163 18.8666 5.48602 17.5058 4.12525C16.1451 2.76447 14.2994 2 12.375 2C10.4506 2 8.60495 2.76447 7.24417 4.12525C5.88338 5.48602 5.1189 7.33163 5.1189 9.25606V13.8292C5.1189 14.3305 4.91975 14.8113 4.56526 15.1658C4.21077 15.5203 3.72998 15.7194 3.22866 15.7194C2.75719 15.7194 2.375 16.1016 2.375 16.5731C2.375 17.0446 2.75719 17.4267 3.22866 17.4267H21.5213C21.9928 17.4267 22.375 17.0446 22.375 16.5731C22.375 16.1016 21.9928 15.7194 21.5213 15.7194ZM10.3643 19.4932C10.7722 19.2566 11.2945 19.3955 11.5311 19.8033C11.6169 19.9511 11.74 20.0738 11.8881 20.1591C12.0362 20.2444 12.2041 20.2893 12.375 20.2893C12.5459 20.2893 12.7138 20.2444 12.8619 20.1591C13.01 20.0738 13.1331 19.9511 13.2189 19.8033C13.4555 19.3955 13.9778 19.2566 14.3857 19.4932C14.7935 19.7298 14.9323 20.2521 14.6957 20.6599C14.4599 21.0665 14.1214 21.404 13.7141 21.6386C13.3068 21.8732 12.845 21.9967 12.375 21.9967C11.905 21.9967 11.4432 21.8732 11.0359 21.6386C10.6286 21.404 10.2901 21.0665 10.0543 20.6599C9.8177 20.2521 9.95653 19.7298 10.3643 19.4932Z"
            fill="#9A9A9A"
          />
        </svg>
        <label class="t-light medium-xs font-family-2">{{
          $t("main.nav.notification")
        }}</label>

        <div
          class="unread_count font-family-1 t-black bold-s"
          v-if="user.getUnreadNotifications > 0"
        >
          {{ user.getUnreadNotifications }}
        </div>
      </button>

      <button class="flex-3 d-flex-column gap-5" @click="openMenu">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.84103 0.400391C1.78877 0.400391 0.125 2.06408 0.125 4.11633C0.125 6.16859 1.78877 7.83228 3.84103 7.83228C5.89329 7.83228 7.55705 6.16859 7.55705 4.11633C7.55705 2.06408 5.89329 0.400391 3.84103 0.400391ZM3.84103 12.168C1.78877 12.168 0.125 13.8317 0.125 15.8839C0.125 17.9362 1.78877 19.5999 3.84103 19.5999C5.89329 19.5999 7.55705 17.9362 7.55705 15.8839C7.55705 13.8317 5.89329 12.168 3.84103 12.168ZM11.8924 4.11633C11.8924 2.06408 13.5562 0.400391 15.6084 0.400391C17.6607 0.400391 19.3244 2.06408 19.3244 4.11633C19.3244 6.16859 17.6607 7.83228 15.6084 7.83228C13.5562 7.83228 11.8924 6.16859 11.8924 4.11633ZM15.6082 12.168C13.556 12.168 11.8922 13.8317 11.8922 15.8839C11.8922 17.9362 13.556 19.5999 15.6082 19.5999C17.6605 19.5999 19.3243 17.9362 19.3243 15.8839C19.3243 13.8317 17.6605 12.168 15.6082 12.168Z"
            fill="#9A9A9A"
          />
        </svg>
        <label class="t-light medium-xs font-family-2">{{
          $t("main.nav.menu")
        }}</label>
      </button>
    </div>
  </div>
</template>

<script setup>
const user = useUserStore();
const genericStore = useGenericStore();
const { getLocale } = useFunctions();

const props = defineProps({
  toggleProfile: {
    default: () => {},
  },
});

const openNotificaiton = () => {
  genericStore.setActiveTab("notification-tab");
  props.toggleProfile();
};
const openChat = () => {
  genericStore.setActiveTab("message-tab");
  props.toggleProfile();
};
const openMenu = () => {
  genericStore.setActiveTab("menu-tab");
  props.toggleProfile();
};

const fetchUnreadNotifications = async () => {
  try {
    const { data } = await useApiPost("/api/get-my-notifications-unread", {
      method: "POST",
      body: {
        locale: getLocale(),
      },
    });
    if (data?.unread_count >= 0) {
      user.setUnreadnotifications(data?.unread_count);
    }
  } catch (error) {
    console.log(error);
  }
};

const fetchUnreadMessages = async () => {
  try {
    const { data } = await useApiPost("/api/get-unread-chats", {
      method: "POST",
      body: {
        locale: getLocale(),
      },
    });
    if (data?.count_of_unread >= 0) {
      user.setUnreadMessages(data?.count_of_unread);
    }
  } catch (error) {
    // console.log(error);
  }
};

await fetchUnreadNotifications();
await fetchUnreadMessages();

const pusherNotifications = async () => {
  window.Echo.private("notification." + user.getUser.id).listen(
    ".fetch.new",
    (e) => {
      console.log("FETCH");
      fetchUnreadNotifications();
    }
  );
};

const pusherChats = async () => {
  window.Echo.private("chats." + user.getUser.id).listen(".fetch.new", (e) => {
    console.log("FETCH");
    fetchUnreadMessages();
  });
};

onNuxtReady(() => {
  pusherNotifications();
  pusherChats();
});

onBeforeUnmount(() => {
  if (user.getUser.id) {
    window.Echo.leave("notification." + user.getUser.id);
    window.Echo.leave("chats." + user.getUser.id);
  }
});
</script>
